export default "__VITE_ASSET__91569f44__"